import ENDPOINTS from '../../constants/apiEndPoints';
import {NetworkDetailsFormValues} from '../../pages/on-boarding/components/NetworkDetails/types';
import {UserItem} from '../../pages/users/components/UserScreens/users';
import {isAdmin, isSuperAdminOnly} from '../../utils';
import {ApiResponse, axiosInstance} from '../axiosInstance';

export type OnBoardingDraftPayload = {
  data: NetworkDetailsFormValues['network'];
  isValidData: boolean;
};

export type OnBoardingDraftResponse = {
  data: NetworkDetailsFormValues['network'];
  isValidData: boolean;
  completedOnboarding?: boolean;
  shouldResyncOnboarding?: boolean;
  createdAt: Date;
  updatedAt: Date;
  lastActivatedAt: Date;
  _id: string;
  user?: UserItem;
};

// Super admins and admin-role users can target/scoped-edit an onboarding
// workspace by draftId or clientId. Network owners always act on their own draft.
export const getOnBoardingTargetSelector = (): string | null => {
  if (!isSuperAdminOnly() && !isAdmin()) return null;

  const searchParams = new URLSearchParams(window.location.search);
  const draftId = searchParams.get('draftId');
  if (draftId) return `draftId:${draftId}`;

  const clientId = searchParams.get('clientId');
  if (clientId) return `clientId:${clientId}`;

  return null;
};

const getOnBoardingRequestConfig = () => {
  if (!isSuperAdminOnly() && !isAdmin()) return undefined;

  const searchParams = new URLSearchParams(window.location.search);
  const draftId = searchParams.get('draftId');
  if (draftId) return {params: {draftId}};

  const clientId = searchParams.get('clientId');
  return clientId ? {params: {clientId}} : undefined;
};

export const handleGetOnBoardingDraftService = async () => {
  const response = await axiosInstance.get<
    ApiResponse<OnBoardingDraftResponse>
  >(ENDPOINTS.GET_UPSERT_ON_BOARDING_DRAFT, getOnBoardingRequestConfig());
  return response?.data?.data;
};

export const handleUpsertOnBoardingDraftService = async (
  payload: OnBoardingDraftPayload,
) => {
  const response = await axiosInstance.post(
    ENDPOINTS.GET_UPSERT_ON_BOARDING_DRAFT,
    payload,
    getOnBoardingRequestConfig(),
  );
  return response?.data;
};

export const handleActivateOnBoardingDraftService = async () => {
  const response = await axiosInstance.post(
    ENDPOINTS.ACTIVATE_ON_BOARDING_DRAFT,
    undefined,
    getOnBoardingRequestConfig(),
  );
  return response?.data;
};

export type CheckEmailsExistResponse = {
  existingEmails: string[];
  results: {email: string; exists: boolean}[];
};

export const handleCheckEmailsExistService = async (
  emails: string[],
): Promise<CheckEmailsExistResponse> => {
  const response = await axiosInstance.post<
    ApiResponse<CheckEmailsExistResponse>
  >(ENDPOINTS.CHECK_EMAILS_EXIST, {emails});
  return response?.data?.data;
};
